export const exploreUris = {
  root: "explore",
  tickets: "tickets",
  conversations: "conversations",
  views: "views",
  view: "views/:slug",
  newView: "views/new",
  editView: "views/:slug/edit",
};
